/* eslint-disable no-restricted-globals */
/* eslint-disable consistent-return */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import debounce from 'lodash.debounce';
import setupAxios from 'lib/axios';
import SessionPoller from '../lib/session-poller';
import '../controllers';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../stylesheets/application.scss';
import StrongPassword from '../helpers/strongPassword';
import initializeDatepickers from '../lib/datepickers';

import { initSortableList } from '../lib/sortable-lists';
import { onDropdownClose } from '../helpers/selectize_helpers';
import computeDisciplines from '../helpers/credentials-disciplines';
import '@ambiki/impulse-view-components/dist/elements/autocomplete';
import '@ambiki/impulse-view-components/dist/elements/popover';
import 'schedules/elements/ajax_partial_element';
import 'jquery-ui';
import 'payroll';
import 'users';

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require.context('../fonts/', true, /\.(eot|ttf|woff|woff2|otf)$/i);

const Rails = require('@rails/ujs');

Rails.start();
const Turbolinks = require('turbolinks');
require('@rails/activestorage').start();
require('channels');
require('../lib/session-poller');
require('bootstrap');
require('../lib/datatables-init');
require('../helpers/nested-fields/addFields');
require('../helpers/nested-fields/removeFields');
const selectize = require('selectize');
require('../lib/autocomplete');
require('../lib/mobile-search');
require('../lib/test-feature-flags');
require('../lib/turbolinks-reloader');
require('helpers/trix-editors');
require('@rails/actiontext');
require('../custom-elements');
require('../lib/dexie');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/sortable');

window.$ = $;

Turbolinks.start();
// Poll for automatic logout detection and redirection
new SessionPoller().init();

// If using a third party plugin like selectize.js that manipulates the DOM,
// unhook it from the elements it's attached to before turbolinks caches it.
document.addEventListener('turbolinks:before-cache', () => {
  removeModals();

  $('.selectized').each(function () {
    if (this.selectize) {
      this.selectize.destroy();
    }
  });

  function removeModals() {
    $('.modal').removeClass('in');
    $('.modal').attr('aria-hidden', 'true');
    $('.modal').css('display', 'none');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
  }
});

// Issue: Turbolinks does not reset scroll position when a new link is clicked
// Try clicking a link the footer to reproduce.
// Using window.scrollTo(0, 0) causes the page to jump to top of the current page before loading
// the new page which is jarring.
// https://github.com/turbolinks/turbolinks/issues/181

(function () {
  // Tell the browser not to handle scrolling when restoring via the history or when reloading
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  const SCROLL_POSITION = 'scroll-position';
  const PAGE_INVALIDATED = 'page-invalidated';

  // Patch the reload method to flag that the following page load originated from the page being invalidated
  Turbolinks.BrowserAdapter.prototype.reload = function () {
    sessionStorage.setItem(PAGE_INVALIDATED, 'true');
    location.reload();
  };

  // Persist the scroll position when leaving a page
  addEventListener('beforeunload', () => {
    sessionStorage.setItem(
      SCROLL_POSITION,
      JSON.stringify({
        scrollX,
        scrollY,
        location: location.href,
      })
    );
  });

  // When a page is fully loaded:
  // 1. Get the persisted scroll position
  // 2. If the locations match and the load did not originate from a page invalidation, scroll to the persisted position
  // 3. Remove the persisted information
  addEventListener('DOMContentLoaded', (event) => {
    const scrollPosition = JSON.parse(sessionStorage.getItem(SCROLL_POSITION));

    if (shouldScroll(scrollPosition)) {
      scrollTo(scrollPosition.scrollX, scrollPosition.scrollY);
    }

    sessionStorage.removeItem(SCROLL_POSITION);
    sessionStorage.removeItem(PAGE_INVALIDATED);
  });

  function shouldScroll(scrollPosition) {
    return (
      scrollPosition &&
      scrollPosition.location === location.href &&
      !JSON.parse(sessionStorage.getItem(PAGE_INVALIDATED))
    );
  }
})();

// Add `X-API-AUTH-TOKEN` header before Turbolinks makes a request
document.addEventListener('ajax:beforeSend', (event) => {
  const xhr = event.detail[0];
  if (!xhr) return;
  const authToken = document.querySelector('meta[name="api-auth-token"]')?.getAttribute('content');
  if (authToken) {
    xhr.setRequestHeader('X-API-AUTH-TOKEN', `Token token=${authToken}`);
  }
});

function initSessionRecording() {
  if (document.getElementById('session-recording-container')) {
    window.pageJSLoading = true;
    import('../pages/session_recording').then((module) => {
      const sessionRecording = module.default;
      if (sessionRecording !== undefined) sessionRecording();
      window.pageJSLoading = false;
    });
  }
}

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}

window.scrollToTop = scrollToTop;

function initTaxonomyRanking(taxonomyInputs) {
  window.pageJSLoading = true;
  import('../lib/taxonomy-inputs').then((module) => {
    const sortableCheckboxes = module.default;
    if (sortableCheckboxes !== undefined) sortableCheckboxes(taxonomyInputs);
    window.pageJSLoading = false;
  });
}

document.addEventListener('turbolinks:load', (event) => {
  setupAxios({ serializeParams: false });
  // Check URL parameters
  // Poller hack to refresh page and maintain scroll position after refresh
  if (window.scrollPosition) {
    window.scrollTo.apply(window, [...window.scrollPosition]);
    window.scrollPosition = null;
  }

  const url = new URL(event.data.url);
  const queryString = url.search;
  const urlParams = new URLSearchParams(queryString);

  // set up datepickers on page
  initializeDatepickers();

  // Show a registration modal
  const registrationTriggers = document.querySelectorAll('.register-modal-trigger');
  if (registrationTriggers.length) {
    registrationTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        window.pageJSLoading = true;
        import('../registration-modal').then((module) => {
          const props = {};
          if (Object.keys(trigger.dataset).length) {
            Object.entries(trigger.dataset).forEach((data) => {
              const [key, value] = data;
              props[key] = value;
            });
          }
          module.default(props);
          window.pageJSLoading = false;
        });
      });
    });
  }

  // Strong Password
  const passwordInput = document.getElementById('password_validator');
  const passConfirmInput = document.getElementById('user_password_confirmation');
  if (passwordInput) {
    const sp = new StrongPassword({ container: passwordInput });
    const debouncedQuery = debounce(() => {
      sp.validate(passwordInput.value).then((valid) => {
        passwordInput.form.querySelector('input[type="submit"]').disabled = !valid;
      });
    }, 200);
    passwordInput.addEventListener('keyup', debouncedQuery);
    if (passConfirmInput) {
      passConfirmInput.addEventListener('keyup', () => {
        const valid = sp.matches(passConfirmInput.value);
        passwordInput.form.querySelector('input[type="submit"]').disabled = !valid;
      });
    }
  }

  // mount selectize

  // messages form and progress report form relies on this to reupdate form when changes are made
  $('.m-select.filterable')
    .selectize({
      create: false,
      sortField: 'id',
      onDropdownClose,
    })
    .on('change', (e) => {
      e.target.dispatchEvent(new Event('selectize-change'));
    });

  // Physical orders selectize component for custom date dropdown.
  $('.po-select.filterable')
    .selectize({
      create: false,
      sortField: 'id',
      onDropdownClose,
    })
    .on('change', (e) => {
      const dateRange = document.getElementById('po-date-range');
      const startDate = document.getElementById('po-start-date');
      const endDate = document.getElementById('po-end-date');
      if (e.target.value === 'custom') {
        dateRange.classList.remove('hidden');
        startDate.setAttribute('required', 'true');
        endDate.setAttribute('required', 'true');
      } else {
        dateRange.classList.add('hidden');
        startDate.removeAttribute('required');
        endDate.removeAttribute('required');
      }
    });

  // set up selectize filterables
  const filterables = $('.select.filterable').selectize({
    create: false,
    sortField: 'id',
    onDropdownClose,
  });

  $('.select.treatability').selectize({
    create: false,
    sortField: 'id',
    onDropdownClose,
    render: {
      option(data, escape) {
        return `<div style="padding: 7px;">${escape(data.text)}<br><small style="color:gray;">${escape(
          data.description
        )}</small></div>`; // https://stackoverflow.com/a/36514076
      },
    },
  });

  // Setup multi select with selectize().
  $('.multi-select').selectize({
    create: false,
    plugins: ['remove_button'],
    searchField: ['text', 'optgroup'],
    delimiter: ',',
  });

  $('.select.filterable-text').selectize({
    create: false,
    sortField: 'text',
    onDropdownClose,
  });

  if (!selectize.prototype.positionDropdownOriginal) {
    selectize.prototype.positionDropdownOriginal = selectize.prototype.positionDropdown;
    selectize.prototype.positionDropdown = function () {
      if (this.settings.dropdownDirection === 'up') {
        const { $control } = this;
        const offset = this.settings.dropdownParent === 'body' ? $control.offset() : $control.position();

        this.$dropdown.css({
          width: $control.outerWidth(),
          top: offset.top - this.$dropdown.outerHeight(),
          left: offset.left,
        });
        this.$dropdown.addClass(`direction-${this.settings.dropdownDirection}`);
        this.$control.addClass(`direction-${this.settings.dropdownDirection}`);
        this.$wrapper.addClass(`direction-${this.settings.dropdownDirection}`);
      } else {
        selectize.prototype.positionDropdownOriginal.apply(this, arguments);
      }
    };
  }

  $('.select.filterable-text-up').selectize({
    create: false,
    sortField: 'text',
    dropdownDirection: 'up',
    onDropdownClose,
  });

  const noSortFilterables = $('.select.filterable-no-sort').selectize({
    create: false,
    onDropdownClose,
  });

  // Vue apps
  const visualScheduleNew = document.getElementById('visual-schedule-new');
  if (visualScheduleNew) {
    window.pageJSLoading = true;
    import('../visual-schedules/new').then((module) => {
      module.default(visualScheduleNew);
      window.pageJSLoading = false;
    });
  }

  const visualScheduleShow = document.getElementById('visual-schedule-show');
  if (visualScheduleShow) {
    window.pageJSLoading = true;
    import('../visual-schedules/show').then((module) => {
      module.default(visualScheduleShow);
      window.pageJSLoading = false;
    });
  }

  const signaturePadCanvas = document.getElementById('signature-pad-canvas');
  if (signaturePadCanvas) {
    window.pageJSLoading = true;
    import('../signature-pad/main').then((module) => {
      module.default(signaturePadCanvas);
      window.pageJSLoading = false;
    });
  }

  const reactionsViewer = document.getElementById('reaction-viewer');
  if (reactionsViewer) {
    window.pageJSLoading = true;
    import('../reactions/viewer').then((module) => {
      module.default(reactionsViewer);
      window.pageJSLoading = false;
    });
  }

  const customerSubscriptions = document.querySelector('.load_stripe');
  if (customerSubscriptions) {
    window.pageJSLoading = true;
    import('subscriptions').then((module) => {
      window.pageJSLoading = false;
    });
  }

  const editProfileBtn = document.getElementById('editProfile');
  if (editProfileBtn) {
    const startingText = editProfileBtn.innerHTML;
    const initProfileEditor = () => {
      document.body.classList.add('no-scroll');
      import('../pages/edit-profile').then((module) => {
        module.default();
        window.pageJSLoading = false;
        editProfileBtn.innerHTML = startingText;
      });
    };
    const editing = urlParams.get('edit');
    if (editing) initProfileEditor();
    editProfileBtn.addEventListener('click', () => {
      editProfileBtn.innerHTML = 'Loading...';
      initProfileEditor();
    });
  }

  const patientForm = document.getElementById('patient_form');
  if (patientForm) {
    window.pageJSLoading = true;
    import('../pages/patient_edit_form').then((module) => {
      const patientEditForm = module.default;
      if (patientEditForm !== undefined) patientEditForm(patientForm);
      window.pageJSLoading = false;
    });
  }

  const stripePatientPortalForm = document.getElementById('stripe-patient-portal-card-payment-form');
  if (stripePatientPortalForm) {
    window.pageJSLoading = true;
    import('../pages/patient_portal_cc_form').then((module) => {
      const patientPortalCCFormForm = module.default;
      if (patientPortalCCFormForm !== undefined) patientPortalCCFormForm(stripePatientPortalForm);
      window.pageJSLoading = false;
    });
  }

  const reviewForm = document.getElementById('ambiki-review');

  if (reviewForm) {
    const stars = document.querySelectorAll('.star');

    stars.forEach((star) => {
      star.addEventListener('click', () => {
        const { rating } = star.dataset;
        document.querySelector('#review_rating').value = rating;

        stars.forEach((s) => {
          s.textContent = s.dataset.rating <= rating ? '★' : '☆';
        });
      });
    });

    const form = document.querySelector('form[data-rating-required="true"]');

    form.addEventListener('submit', (ratingEvent) => {
      const rating = document.querySelector('#review_rating').value;

      if (!rating) {
        ratingEvent.preventDefault();
        alert('The rating is required. Please select a rating. Thank you!');
      }
    });
  }

  const referenceLinkForm = document.getElementById('reference_link_modal_form');
  if (referenceLinkForm) {
    referenceLinkForm.addEventListener('ajax:error', () => {
      document.getElementById('completion-message').innerHTML =
        '<div class="alert alert-danger" role="alert">Sorry, there was a problem saving your reference link.</div>';
    });
  }

  const taxonomyInitialized = {
    'v-pills-service-areas-tab': false,
    'v-pills-specialties-tab': false,
    'v-pills-disorders-tab': false,
  };

  const isTabbedInterface = document.querySelectorAll('ul.nav.nav-pills li.nav-item a.nav-link').length > 0;

  // Taxonomy Sortable Checkbox Inputs for Rails forms
  const taxonomyInputs = [...document.querySelectorAll('.taxonomy-input')];

  if (taxonomyInputs.length) {
    if (isTabbedInterface) {
      // Initialize only when the corresponding tab is in focus
      $('ul.nav.nav-pills li.nav-item a.nav-link').on('shown.bs.tab', (e) => {
        const target = $(e.target).attr('id');
        if (
          ['v-pills-service-areas-tab', 'v-pills-specialties-tab', 'v-pills-disorders-tab'].includes(target) &&
          !taxonomyInitialized[target]
        ) {
          const relevantTaxonomyInputs = taxonomyInputs.filter((el) => el.getAttribute('data-tab') === target);
          initTaxonomyRanking(relevantTaxonomyInputs);
          taxonomyInitialized[target] = true;
        }
      });
    } else {
      // Initialize immediately if no tabs exist
      initTaxonomyRanking(taxonomyInputs);
      Object.keys(taxonomyInitialized).forEach((key) => {
        taxonomyInitialized[key] = true;
      });
    }
  }

  if (document.getElementById('goals-show')) {
    // https://stackoverflow.com/a/59495659/1276696
    window.pageJSLoading = true;
    import('../pages/goals-show').then((module) => {
      const goals = module.default;
      if (goals !== undefined) goals();
      window.pageJSLoading = false;
    }); // webpack will load this JS async
  }

  if (document.getElementById('tenalog-editor-container')) {
    window.pageJSLoading = true;
    import('../pages/tenalog_editor').then((module) => {
      const tenalogEditor = module.default;
      if (tenalogEditor !== undefined) tenalogEditor();
      window.pageJSLoading = false;
    });
  }

  let sessionRecordingInitialized = false;

  const transcriptTab = document.getElementById('v-pills-transcript-tab');
  if (transcriptTab) {
    if (transcriptTab.classList.contains('active') && !sessionRecordingInitialized) {
      initSessionRecording();
      sessionRecordingInitialized = true;
    }
  }

  $('#v-pills-SessionRecordingTabs a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
    const target = $(e.target).attr('href');
    if (target === '#v-pills-transcript' && !sessionRecordingInitialized) {
      initSessionRecording();
      sessionRecordingInitialized = true;
    }
  });

  if (document.getElementById('heatmap-calendar')) {
    window.pageJSLoading = true;
    import('../pages/patient_progress').then((module) => {
      const progress = module.default;
      if (progress !== undefined) progress();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('billingDataModal')) {
    window.pageJSLoading = true;
    import('../pages/billing_modal_service_rates').then((module) => {
      const billingModal = module.default;
      if (billingModal !== undefined) billingModal();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('tenalog-credit-form')) {
    window.pageJSLoading = true;
    import('../pages/subscription_index').then((module) => {
      const subscriptionIndex = module.default;
      if (subscriptionIndex !== undefined) subscriptionIndex();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('mvp_reel')) {
    window.pageJSLoading = true;
    import('../pages/mvp_reels').then((module) => {
      const mvpReels = module.default;
      if (mvpReels !== undefined) mvpReels();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('therapy_activities_show')) {
    window.pageJSLoading = true;
    import('../pages/therapy_activities').then((module) => {
      const therapyActivities = module.default;
      if (therapyActivities !== undefined) therapyActivities();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('stg_ltg_goals_show')) {
    window.pageJSLoading = true;
    import('../pages/stg_ltg_goals').then((module) => {
      const stgLtgGoals = module.default;
      if (stgLtgGoals !== undefined) stgLtgGoals();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('words-show')) {
    window.pageJSLoading = true;
    import('../pages/words-show').then((module) => {
      const words = module.default;
      if (words !== undefined) words();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('admin-dashboard-stats')) {
    // https://stackoverflow.com/a/59495659/1276696
    window.pageJSLoading = true;
    import('../pages/admin-dashboard-stats').then((module) => {
      const adminStats = module.default;
      if (adminStats !== undefined) adminStats();
      window.pageJSLoading = false;
    }); // webpack will load this JS async
  }

  if (document.getElementById('phoeneme-graphs')) {
    // https://stackoverflow.com/a/59495659/1276696
    window.pageJSLoading = true;
    import('../pages/phoneme-graphs').then((module) => {
      const phonemeGraphs = module.default;
      if (phonemeGraphs !== undefined) phonemeGraphs();
      window.pageJSLoading = false;
    }); // webpack will load this JS async
  }

  if (document.getElementById('organization-dashboard-graphs')) {
    // https://stackoverflow.com/a/59495659/1276696
    window.pageJSLoading = true;
    import('../pages/organization-dashboard-graphs').then((module) => {
      const organizationGraphs = module.default;
      if (organizationGraphs !== undefined) organizationGraphs();
      window.pageJSLoading = false;
    }); // webpack will load this JS async
  }

  if (document.getElementById('patient-invoice-payments-new-form')) {
    window.pageJSLoading = true;
    import('../pages/patient_invoice_payments').then((module) => {
      const patientInvoicePayments = module.default;
      if (patientInvoicePayments !== undefined) patientInvoicePayments();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('custom-sanitizer-whitelist')) {
    window.pageJSLoading = true;
    import('../lib/tooltip_sanitization').then((module) => {
      const tooltipSanitization = module.default;
      if (tooltipSanitization !== undefined) tooltipSanitization();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('visit-note-therapy-activities-table')) {
    window.pageJSLoading = true;
    import('../pages/visit_note_therapy_activities').then((module) => {
      const visitNoteTherapyActivity = module.default;
      if (visitNoteTherapyActivity !== undefined) visitNoteTherapyActivity();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('visit_note_new_form')) {
    window.pageJSLoading = true;
    import('../pages/visit_note_new').then((module) => {
      const visitNoteNew = module.default;
      if (visitNoteNew !== undefined) visitNoteNew();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('connection-stat-container')) {
    window.pageJSLoading = true;
    import('../pages/rooms-sessions-webrtc-stats').then((module) => {
      const stats = module.default;
      if (stats !== undefined) stats();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('pacingGraph')) {
    window.pageJSLoading = true;
    import('../pages/cache-pacing-graph-show').then((module) => {
      const graph = module.default;
      if (graph !== undefined) graph();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('subscriptionBreakdownGraph')) {
    window.pageJSLoading = true;
    import('../pages/customer-subscriptions/user-subscription-graph').then((module) => {
      const graph = module.default;
      if (graph !== undefined) graph();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('blog-post-form')) {
    window.pageJSLoading = true;
    import('../pages/blog_posts').then((module) => {
      const blogPostEditor = module.default;
      if (blogPostEditor !== undefined) blogPostEditor();
      window.pageJSLoading = false;
    });
  }

  if (document.getElementById('games-show')) {
    if (document.getElementById('collocation_contemplation') || document.getElementById('minimal-pair-mayhem')) {
      const answer = document.getElementById('game-answer');
      const btn = document.getElementById('try-answer');
      const score = document.getElementById('boardScore');
      const wrong_answer_1 = document.getElementById('wrong_answer_1');
      const wrong_answer_2 = document.getElementById('wrong_answer_2');
      const wrong_answer_3 = document.getElementById('wrong_answer_3');
      const answer_1 = document.getElementById('answer_1');
      const answer_2 = document.getElementById('answer_2');
      const answer_3 = document.getElementById('answer_3');
      const attempt_1 = document.getElementById('attempt_1');
      const attempt_2 = document.getElementById('attempt_2');
      const attempt_3 = document.getElementById('attempt_3');
      const btnHolderContainer = document.getElementById('btnHolderContainer');
      const cards = document.getElementsByClassName('cardContainer');
      const words = [];
      let wrong_answers = 0;

      for (let i = 0; i < cards.length; i += 1) {
        var card = cards[i];
        words.push(card.getAttribute('data-word'));
      }

      function showAnswer(el) {
        if (!el.firstElementChild.classList.contains('row')) {
          while (el.firstChild) {
            el.removeChild(el.firstChild);
          }
          const item_score = el.getAttribute('data-score');
          const item_word = el.getAttribute('data-word');
          const div_item = document.createElement('div');
          div_item.classList.add('cardHolder');
          div_item.classList.add('row');
          const div_left = document.createElement('div');
          const div_right = document.createElement('div');
          div_left.classList.add('col-9');
          div_left.classList.add('back');
          div_right.classList.add('col-3');
          div_right.classList.add('front');
          div_right.classList.add('scoreValueContainer');
          div_right.classList.add('text-center');
          const div_inner = document.createElement('p');
          div_inner.classList.add('mb-0');
          const div_inner_score = document.createElement('p');
          div_inner_score.classList.add('scoreValue');

          div_inner.innerHTML = item_word;
          div_inner_score.innerHTML = item_score;
          div_left.appendChild(div_inner);
          div_right.appendChild(div_inner_score);
          div_item.appendChild(div_left);
          div_item.appendChild(div_right);
          el.appendChild(div_item);
        }
      }

      answer.addEventListener('input', function (evt) {
        if (this.value.length > 0) {
          btn.removeAttribute('disabled');
        } else {
          btn.setAttribute('disabled', 'disabled');
        }
      });

      btn.onclick = function () {
        btn.setAttribute('disabled', 'disabled');
        const userAnswer = answer.value.toLowerCase();
        if (words.includes(userAnswer)) {
          const correct_answers = document.querySelectorAll(`[data-word='${userAnswer}']`);
          for (var i = 0; i < correct_answers.length; i += 1) {
            var el = correct_answers[i];
            const item_score = el.getAttribute('data-score');
            score.innerHTML = parseInt(score.innerHTML, 10) + parseInt(item_score, 10);
            showAnswer(el);
            el.firstElementChild.style.border = '2px solid #4cfe39';
          }
          answer.value = '';
        } else {
          wrong_answers += 1;
          if (wrong_answers === 1) {
            wrong_answer_1.classList.remove('hide');
            answer_1.classList.add('hide');
            attempt_1.innerHTML = userAnswer;
            answer.value = '';
          } else if (wrong_answers === 2) {
            wrong_answer_2.classList.remove('hide');
            answer_2.classList.add('hide');
            attempt_2.innerHTML = userAnswer;
            answer.value = '';
          } else if (wrong_answers === 3) {
            wrong_answer_3.classList.remove('hide');
            answer_3.classList.add('hide');
            attempt_3.innerHTML = userAnswer;
            answer.value = 'Game Over 😞';
            answer.disabled = true;
            btn.parentNode.removeChild(btn);

            const new_button = document.createElement('button');
            new_button.classList.add('btn');
            new_button.classList.add('btn-success');
            new_button.classList.add('mt-2');
            new_button.id = 'play_again';
            new_button.innerHTML = 'Play Again';
            btnHolderContainer.appendChild(new_button);

            new_button.onclick = function () {
              if (document.getElementById('collocation_contemplation')) {
                location.href = '/games/collocation-contemplation';
              } else if (document.getElementById('minimal-pair-mayhem')) {
                location.href = '/games/minimal-pair-mayhem';
              }
            };

            for (var i = 0; i < cards.length; i += 1) {
              var el = cards[i];
              showAnswer(el);
            }
          }
        }
      };
    }
    if (document.getElementById('recollection_perfection')) {
      let flippedCards = [];
      let flippedWords = [];

      function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
      }

      function delay(card) {
        setTimeout(() => {
          card.classList.remove('flipped');
          card.classList.remove('red-border');
        }, 2000);
      }

      const cards = document.getElementsByClassName('kiki-card');

      function lock() {
        document.getElementById('locked').classList.remove('hide');
      }

      function unlock() {
        setTimeout(() => {
          flippedCards = [];
          flippedWords = [];
          document.getElementById('locked').classList.add('hide');
        }, 2000);
      }

      function winner() {
        setTimeout(() => {
          alert('You got them all! Great job!!');
          document.getElementById('play_again').classList.remove('hide');
        }, 200);
      }

      for (let i = 0; i < cards.length; i += 1) {
        var card = cards[i];
        card.onclick = function () {
          const word = this.getAttribute('data-word');
          const index = this.id;
          if (!flippedCards.includes(index)) {
            flippedCards.push(index);
            flippedWords.push(word);
            const unique = flippedWords.filter(onlyUnique);
            if (flippedCards.length < 3) {
              this.classList.add('flipped');
            }

            if (flippedWords.length === 2 && unique.length === 1) {
              for (var j = 0; j < flippedCards.length; j += 1) {
                var reflip_card = document.getElementById(flippedCards[j]);
                reflip_card.classList.add('green-border');
              }
              flippedCards = [];
              flippedWords = [];
              const sets = document.getElementsByClassName('green-border');
              if (
                sets.length ===
                parseInt(document.getElementById('recollection_perfection').getAttribute('data-total'), 10) * 2
              ) {
                winner();
              }
            } else if (flippedWords.length === 2 && unique.length > 1) {
              for (var j = 0; j < flippedCards.length; j += 1) {
                var reflip_card = document.getElementById(flippedCards[j]);
                delay(reflip_card);
                reflip_card.classList.add('red-border');
                lock();
              }
              unlock();
            }
          }
        };
      }
    }

    function removeChosenWords() {
      const checkRemovalApproval = document.getElementById('removeChosenWords').checked;
      if (checkRemovalApproval) {
        const chosenWords = document.getElementsByClassName('border-dice-selected');
        const numberOfWordsChosen = chosenWords.length;
        for (let i = 0; i < numberOfWordsChosen; i += 1) {
          chosenWords[0].remove();
        }
      }
    }

    if (document.getElementById('spin_control')) {
      const spinner_count = parseInt(document.getElementById('spin_control').getAttribute('data-total'), 10);
      const spinner = document.querySelector('.spinner');
      const startBtn = document.querySelector('.spinner_start-button');
      let plate = document.querySelector('.spinner_plate');
      let items = [...document.getElementsByClassName('spinner_item')];
      let numbers = [];
      let spinTimeout;

      startBtn.addEventListener('click', () => {
        randomizeItems();
        removeChosenWords();

        if (!plate.classList.contains('spinner_plate-spin')) {
          plate.classList.add('spinner_plate-spin');
        } else {
          const currPlate = plate;
          const newPlate = plate.cloneNode(true);
          currPlate.parentNode.replaceChild(newPlate, currPlate);
          plate = newPlate;
          items = [...document.getElementsByClassName('spinner_item')];
        }

        clearTimeout(spinTimeout);
        const words = document.getElementsByClassName('dice_container');
        for (let i = 0; i < words.length; i += 1) {
          const el = words[i];
          el.classList.add('border-dice');
          el.classList.remove('border-dice-selected');
        }

        spinTimeout = setTimeout(() => {
          for (let i = 0; i < words.length; i += 1) {
            const el = words[i];
            const total = el.getAttribute('data-counter');
            if (parseInt(total, 10) === numbers[0]) {
              el.classList.remove('border-dice');
              el.classList.add('border-dice-selected');
            }
          }
        }, 2000);
      });

      function randomizeItems() {
        numbers = [];
        items.forEach((item) => {
          const rand = random(1, +spinner_count);
          numbers.push(rand);
          item.textContent = rand;
        });
      }

      function random(min, max) {
        const rand = min - 0.5 + Math.random() * (max - min + 1);
        return Math.round(rand);
      }
    }
    if (document.getElementById('icy_dicey')) {
      let diceTimeout;

      function rollDice() {
        clearTimeout(diceTimeout);
        removeChosenWords();
        const words = document.getElementsByClassName('dice_container');
        for (let i = 0; i < words.length; i += 1) {
          const el = words[i];
          el.classList.add('border-dice');
          el.classList.remove('border-dice-selected');
        }

        const dice = [...document.querySelectorAll('.die-list')];
        let dice_sum = 0;
        const numbers = [];
        dice.forEach((die) => {
          toggleClasses(die);
          const number = getRandomNumber(1, 6);
          numbers.push(number);
          dice_sum += number;
          die.dataset.roll = number;
        });
        diceTimeout = setTimeout(() => {
          for (let i = 0; i < words.length; i += 1) {
            const el = words[i];
            if (el.hasAttribute('data-total')) {
              const total = el.getAttribute('data-total');
              if (parseInt(total, 10) === dice_sum) {
                el.classList.remove('border-dice');
                el.classList.add('border-dice-selected');
              }
            } else {
              const number_1 = parseInt(el.getAttribute('data-num1'), 10);
              const number_2 = parseInt(el.getAttribute('data-num2'), 10);
              if (
                (numbers[0] === number_1 && numbers[1] === undefined) ||
                ((numbers[0] === number_1 || numbers[0] === number_2) &&
                  (numbers[0] === number_2 || numbers[1] === number_2) &&
                  (numbers[1] === number_1 || numbers[1] === number_2) &&
                  (numbers[0] === number_1 || numbers[1] === number_1))
              ) {
                el.classList.remove('border-dice');
                el.classList.add('border-dice-selected');
              }
            }
          }
        }, 2000);
      }

      function toggleClasses(die) {
        die.classList.toggle('odd-roll');
        die.classList.toggle('even-roll');
      }

      function getRandomNumber(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      document.getElementById('roll_button').addEventListener('click', rollDice);
    }

    if (document.getElementById('kikis_word_guess')) {
      const letters = document.getElementsByClassName('letterBtn');
      const word = document.getElementById('kikis_word_guess').getAttribute('data-word').toLowerCase();
      const kikiHolder = document.getElementById('kiki_holder');
      const kikiImages = document.getElementsByClassName('kiki');
      let incorrect_guesses = 0;

      function getIndicesOf(searchStr, str, caseSensitive) {
        const searchStrLen = searchStr.length;
        if (searchStrLen === 0) {
          return [];
        }
        let startIndex = 0;
        let index;
        const indices = [];
        if (!caseSensitive) {
          str = str.toLowerCase();
          searchStr = searchStr.toLowerCase();
        }
        while ((index = str.indexOf(searchStr, startIndex)) > -1) {
          indices.push(index);
          startIndex = index + searchStrLen;
        }
        return indices;
      }

      for (let y = 0; y < letters.length; y += 1) {
        const letter = letters[y];

        letter.onclick = function () {
          document.getElementById('final_design').classList.add('hide');
          if (incorrect_guesses === 0) {
            document.getElementById('transparent').classList.remove('hide');
          }
          this.setAttribute('disabled', 'disabled');

          const chosen_letter = this.id.split('_')[1].toLowerCase();

          const indicies = getIndicesOf(chosen_letter, word, false);

          if (indicies.length > 0) {
            for (var i = 0; i < indicies.length; i += 1) {
              const index = indicies[i];
              var el = document.getElementById(`index_${index}`);
              el.classList.add('answer');
              el.classList.remove('blank');
              el.innerHTML = el.getAttribute('data-letter');
            }
          } else {
            incorrect_guesses += 1;

            var el = document.getElementById(`design_0${incorrect_guesses}`);
            for (var i = 0; i < kikiImages.length; i += 1) {
              var image = kikiImages[i];
              image.classList.add('hide');
            }

            el.classList.remove('hide');
            if (incorrect_guesses === 7) {
              for (var i = 0; i < letters.length; i += 1) {
                letters[i].setAttribute('disabled', 'disabled');
              }
              document.getElementById('design_07').classList.add('hide');
              document.getElementById('game_over').classList.remove('hide');
              document.getElementById('play_again_button').classList.remove('hide');
              const blanks = document.getElementsByClassName('blank');
              for (var i = 0; i < blanks.length; i += 1) {
                var el = blanks[i];
                el.innerHTML = el.getAttribute('data-letter');
              }
            }
          }
          if (document.getElementsByClassName('blank').length === 0) {
            for (var i = 0; i < kikiImages.length; i += 1) {
              var image = kikiImages[i];
              image.classList.add('hide');
            }
            document.getElementById('got_it').classList.remove('hide');
            document.getElementById('play_again_button').classList.remove('hide');
          }
        };
      }
    }
  }

  // Remove unused parameters from URL in GET request by disabling the form fields
  $('.search-get-form').on('submit', () => {
    $('input').each(function () {
      if ($(this).val() === '') {
        $(this).attr('disabled', true);
      }
    });

    $('select').each(function () {
      if ($(this).val() === '' || $(this).val() === null || $(this).val() === undefined) {
        $(this).attr('disabled', true);
      }
    });

    $('button').each(function () {
      $(this).attr('disabled', true);
    });
  });

  // @TODO - We need to refactor all of this. Remove stuff not being used, pull out code to different file and make
  // selectize configs customizable by data attributes instead of unique instance creation
  const REGEX_EMAIL =
    "([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@" +
    '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)';
  // Selectize initialization
  $('.taggable-email-input').selectize({
    plugins: ['remove_button'],
    delimiter: ',',
    createOnBlur: true,
    persist: false,
    onDropdownClose,
    createFilter(input) {
      const regex = new RegExp(`^${REGEX_EMAIL}$`, 'i');
      const match = input.match(regex);
      if (match) return !this.options.hasOwnProperty(match[0]);
      return false;
    },
    create(input) {
      if (new RegExp(`^${REGEX_EMAIL}$`, 'i').test(input)) {
        return {
          value: input,
          text: input,
        };
      }
      alert('Invalid email address.');
      return false;
    },
  });

  $('.taggable').selectize({
    plugins: ['remove_button'],
    delimiter: ',',
    createOnBlur: false,
    persist: false,
  });

  const preservePlaceholder = (placeholderSelectize) => {
    const placeholder = placeholderSelectize.$input[0].getAttribute('placeholder');
    if (placeholder) {
      placeholderSelectize.$control_input[0].placeholder = placeholder;
    }
  };

  $('.select.school-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    maxItems: 1,
    placeholder: 'Start typing to search for a school...',
    options: [],
    preload: true,
    create: false,
    onDropdownClose,
    load(query, callback) {
      if (!query) return callback();
      $.ajax({
        url: '/api/v2/schools',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
    onChange(value) {
      const select = this.$input[0];
      const option = select.options[0];
      option.value = value;
      select.value = value;
    },
    onInitialize() {
      preservePlaceholder(this);
      const select = this.$input[0].dataset;
      $.ajax({
        url: '/api/v2/schools',
        type: 'GET',
        dataType: 'json',
        data: {
          q: select.name,
        },
        error(e) {
          console.log(e);
        },
        success: (res) => {
          if (!res) return;
          this.addOption(res);
          const selectedItems = [];
          selectedItems.push(select.id);
          this.addItem(selectedItems);
        },
      });
    },
  });

  $('.select.district-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    maxItems: 1,
    placeholder: 'Start typing to search for a district...',
    options: [],
    preload: true,
    create: false,
    onDropdownClose,
    load(query, callback) {
      if (!query) return callback();
      $.ajax({
        url: '/api/v2/districts',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
    onChange(value) {
      const select = this.$input[0];
      const option = select.options[0];
      option.value = value;
      select.value = value;
    },
    onInitialize() {
      preservePlaceholder(this);
      const select = this.$input[0].dataset;
      const $selectizeContainer = this.$input[0];
      const data = {
        q: select.name,
      };
      if ($selectizeContainer.classList.contains('lazy-load')) {
        data.limit_initial = 5;
      }
      $.ajax({
        url: '/api/v2/districts',
        type: 'GET',
        dataType: 'json',
        data,
        error(e) {
          console.log(e);
        },
        success: (res) => {
          if (!res) return;
          this.addOption(res);
          const selectedItems = [];
          selectedItems.push(select.id);
          this.addItem(selectedItems);
        },
      });
    },
  });

  $('.select.npi-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    maxItems: 1,
    placeholder: 'Start typing to search for a provider...',
    options: [],
    preload: true,
    create: false,
    onDropdownClose,
    load(query, callback) {
      const select = this.$input[0];
      if (!query) return callback();
      $.ajax({
        url: '/api/v2/npi-search',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          if (!res || !res[0]) return;

          const result = res[0];

          if (result.first_name) select.closest('div').querySelector('.provider_first_name').value = result.first_name;
          if (result.last_name) select.closest('div').querySelector('.provider_last_name').value = result.last_name;
          if (result.middle_name)
            select.closest('div').querySelector('.provider_middle_name').value = result.middle_name;
          if (result.organization_name)
            select.closest('div').querySelector('.provider_organization_name').value = result.organization_name;
          if (result.suffix) select.closest('div').querySelector('.provider_suffix').value = result.suffix;
          if (result.active) select.closest('div').querySelector('.provider_active').value = result.active;
          if (result.primary_taxonomy_name)
            select.closest('div').querySelector('.provider_primary_taxonomy_name').value = result.primary_taxonomy_name;
          if (result.primary_taxonomy_number)
            select.closest('div').querySelector('.provider_primary_taxonomy_number').value =
              result.primary_taxonomy_number;

          callback(res);
        },
      });
    },
    onChange(value) {
      const select = this.$input[0];
      $.ajax({
        url: '/api/v2/npi-search',
        type: 'GET',
        dataType: 'json',
        data: {
          q: value,
        },
        error(err) {
          console.log(err);
        },
        success(res) {
          // disable add button till parameters are rightly set
          if (!res || !res[0]) return;
          const result = res[0];

          const addProviderButton = document.getElementById('add-provider-button');
          const providerSpinner = document.getElementById('provider-spinner');
          const addProviderIcon = document.getElementById('add-provider-icon');
          const delineationElement = select.closest('div').querySelector('.addressAttributeDelineation');
          let addressAttributeDelineation;

          if (delineationElement) {
            addressAttributeDelineation = delineationElement.dataset.delineation;
          }

          // show spinner and remove add provider button
          if (addProviderButton) {
            providerSpinner.classList.remove('d-none');
            addProviderIcon.classList.add('d-none');
            addProviderButton.disabled = true;
          }

          // set provider attributes
          if (result.first_name) select.closest('div').querySelector('.provider_first_name').value = result.first_name;
          if (result.last_name) select.closest('div').querySelector('.provider_last_name').value = result.last_name;
          if (result.middle_name)
            select.closest('div').querySelector('.provider_middle_name').value = result.middle_name;
          if (result.organization_name)
            select.closest('div').querySelector('.provider_organization_name').value = result.organization_name;
          if (result.suffix) select.closest('div').querySelector('.provider_suffix').value = result.suffix;
          if (result.active) select.closest('div').querySelector('.provider_active').value = result.active;
          if (result.primary_taxonomy_name)
            select.closest('div').querySelector('.provider_primary_taxonomy_name').value = result.primary_taxonomy_name;
          if (result.primary_taxonomy_number)
            select.closest('div').querySelector('.provider_primary_taxonomy_number').value =
              result.primary_taxonomy_number;

          // do not set address attributes if there is no address attributes delineator
          if (!addressAttributeDelineation) {
            return;
          }

          const states = {
            AL: '792cb3da-b81d-4b84-9fe2-5eb2e8ba2fe1',
            AK: '9761b2a2-64e3-44b7-ade7-8048a005b464',
            AZ: '5a2065a2-ff3c-44a9-9700-27478430ca5a',
            AR: '79a51f67-061b-4ab8-bf0e-89803c848190',
            CA: 'f8304174-c9d1-426d-9fe8-ed8b8ccc111b',
            CO: 'f8a476d8-f08c-4edf-a899-17ed68012611',
            CT: '7bacf4b6-0333-4079-81b3-4a132e533cac',
            DE: '3020b27e-e1ee-4e00-8ddc-632c15e174b0',
            FL: '31aab059-4059-468e-8093-3d43ddf784f6',
            GA: '35c4d00d-12c4-454d-b07c-0ae6fa3cf07e',
            HI: '20b70c99-1e4d-4c31-b080-2eee352b25d4',
            ID: '7dc74aa6-7dba-41e4-81e4-00e70dc276f2',
            IL: 'e9520da2-4db6-4394-9267-42d36ac9d414',
            IN: '5fffbfda-9a70-41ce-adef-6744af74bd33',
            IA: '9ca6d9ee-f97c-4ae4-87c7-8c48406338ab',
            KS: '86439c19-917e-43fa-820c-ca275e10ab91',
            KY: 'b3724b8d-2661-4d7b-9cba-efb79b13a3c5',
            LA: '4d1e896f-ffbd-4e58-ae27-04e9a61b98e9',
            ME: '22a7dc8e-b87d-4992-b6c7-4cd4f3fe351f',
            MD: 'da24b130-4488-4c33-a6e4-c7f1eecec046',
            MA: 'edd0adb7-cbce-486d-bff7-b9022b784ca0',
            MI: 'aeda968a-ddbb-402a-9553-6f7625b78d60',
            MN: 'df15f16d-0c20-45ae-b9ba-61caa5793599',
            MS: 'dd164fcb-7e1f-4f60-ad09-a82cff9c8c83',
            MO: '74926e67-b6e0-4bf6-936f-fbfb901a3628',
            MT: 'cb15ecc7-e6bc-4cec-abce-ed9c67f20132',
            NE: 'fada5e0c-d1fc-4903-b692-656e1ff67e90',
            NV: 'b2084b65-cf73-4dd6-aff0-9c3e04af758c',
            NH: '8ea0d008-37b7-4f0a-ac0e-f9fd9dbc4e9b',
            NJ: 'f59d589f-1a76-43c6-b5cb-33e1b633c666',
            NM: 'fd639e11-14f2-4596-b771-ade4fe42641f',
            NY: 'cc87d550-2fff-4eb4-ada0-1ee7928f7ce9',
            NC: 'bb8e1276-f348-48bb-af1d-19e670289706',
            ND: '75e3b344-c84a-4087-ae05-15556b5188ba',
            OH: 'c97f229b-5ea2-4e72-94a0-b747863ed408',
            OK: '336758ff-ad13-41a4-80c2-7b812e6e34af',
            OR: 'f42355d8-1282-4241-b063-5d77ebe2d682',
            PA: '9e4547c7-be31-4ebe-8471-75647fa2e1cd',
            RI: '07cedcb1-71a3-4653-9f88-03e5f4e34632',
            SC: 'ada5b0f2-4e86-4b28-8a03-b4d954fe40f2',
            SD: '62e2edb0-5b96-41b8-a75f-5294c9fde059',
            TN: '3e9e112c-3954-4001-b180-aac3a71a334c',
            TX: '45c2200c-3d40-4d59-886d-69f95863bb93',
            UT: '693d1508-dea8-4227-b168-0f343390bb5a',
            VT: 'e4aba46b-6bf3-498f-b9fc-4d0156b3630a',
            VA: 'cd92b344-01ce-44ed-b27d-dc9b2dc53387',
            WA: '8417da33-6057-4607-8770-d3dc46acfd62',
            WV: 'a188df66-9d72-492e-a5d3-61af7c3b7b03',
            WI: '1a9a1b72-229f-433d-8ae1-c0aae33845b2',
            WY: '24792adb-2104-470e-b007-89941e449edc',
            DC: '2d568ff0-0456-48c8-9ff4-c04fb8836185',
            PR: '80ceb63b-928d-4112-9e12-67f9388c17f4',
            AS: 'f4a3b53d-dd70-41d3-96f8-5fb4f269c492',
            GU: '17297d90-6e71-437b-ad5c-7cdeb6fa0d59',
            VI: 'c09bb695-c2f2-4db7-b4b1-273eba209e5b',
            FM: '5da2e734-c0b8-4858-b6dc-3a5b6508c8a1',
            MH: '600bd931-29e6-4274-b356-c230390a49a3',
            MP: 'c6e554e0-4697-4e0e-8151-3c428456605c',
            PW: '828066ee-7ae4-4176-9087-2e752434998f',
          };

          const addressTypes = {
            'LOCATION AND MAILING': 'f6749b20-b2e5-4992-bf11-6e5585b5df70',
            LOCATION: '319705a9-f58e-4da2-9dd7-dacdfb7a1e42',
            MAILING: 'ea876400-61b4-4bb9-a37e-b6a2171d88ab',
          };

          const phoneNumberTypes = {
            telephone_number: '80e9a6e6-14b5-4bff-9b48-bad20308eef6',
            fax_number: '31053637-ac84-4f96-8844-3bc829f3a251',
          };

          const fields = [
            'address_1',
            'address_2',
            'address_purpose',
            'address_type',
            'city',
            'country_code',
            'country_name',
            'fax_number',
            'postal_code',
            'state',
            'telephone_number',
          ];

          const mapFields = {
            address_1: 'address',
            address_2: 'address_2',
            // purpose is what we call addresstype
            address_purpose: 'address_type_id',
            address_type: '',
            city: 'city',
            country_code: 'country_code',
            country_name: 'country_name',
            fax_number: 'fax_number',
            postal_code: 'zip_code',
            state: 'state_id',
            telephone_number: 'telephone_number',
          };

          // set address and phone number attribute values
          for (let index = 0; index < result.addresses.length; index += 1) {
            const address = result.addresses[index];
            // set phone numbers(telephone and fax)
            const workPhoneElement = document.getElementById(
              `${addressAttributeDelineation}_${index}_phone_numbers_attributes_0_number`
            );
            const workPhoneTypeElement = document.getElementById(
              `${addressAttributeDelineation}_${index}_phone_numbers_attributes_0_phone_number_type_id`
            );
            const workFaxElement = document.getElementById(
              `${addressAttributeDelineation}_${index}_phone_numbers_attributes_1_number`
            );
            const workFaxTypeElement = document.getElementById(
              `${addressAttributeDelineation}_${index}_phone_numbers_attributes_1_phone_number_type_id`
            );

            if (workPhoneElement && workPhoneTypeElement && address.telephone_number) {
              workPhoneElement.value = address.telephone_number;
              workPhoneTypeElement.value = phoneNumberTypes.telephone_number;
            }

            if (workFaxElement && workFaxTypeElement && address.fax_number) {
              workFaxElement.value = address.fax_number;
              workFaxTypeElement.value = phoneNumberTypes.fax_number;
            }

            // set other address fields
            for (let idx = 0; idx < fields.length; idx += 1) {
              const field = fields[idx];
              const mappedField = mapFields[field];
              let fieldValue = address[field];
              const id = `${addressAttributeDelineation}_${index}_${mappedField}`;
              const fieldElement = document.getElementById(id);
              if (field === 'address_purpose') {
                fieldValue = addressTypes[fieldValue];
              } else if (field === 'state') {
                fieldValue = states[fieldValue];
              } else if (field === 'postal_code') {
                fieldValue =
                  fieldValue && fieldValue.length > 5 ? `${fieldValue.slice(0, 5)}-${fieldValue.slice(5)}` : fieldValue;
              }

              if (fieldValue && fieldElement) fieldElement.value = fieldValue;
            }
          }

          if (addProviderButton) {
            // re-enable add provider button with delay to allow parameters all set
            setTimeout(() => {
              addProviderButton.disabled = false;
              providerSpinner.classList.add('d-none');
              addProviderIcon.classList.remove('d-none');
            }, 1500);
          }
        },
      });
    },
    onInitialize() {
      preservePlaceholder(this);
      const select = this.$input[0].dataset;
      $.ajax({
        url: '/api/v2/npi-search',
        type: 'GET',
        dataType: 'json',
        data: {
          q: select.id,
        },
        error(e) {
          console.log(e);
        },
        success: (res) => {
          if (!res) return;
          this.addOption(res);
          const selectedItems = [];
          selectedItems.push(select.id);
          this.addItem(selectedItems);
        },
      });
    },
  });

  $('.select.diagnosis-code-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    placeholder: 'Start typing to search for a diagnosis code...',
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/diagnosis-codes',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  $('.select.goal-select').selectize({
    valueField: 'id',
    labelField: 'goal',
    searchField: 'goal',
    placeholder: 'Start typing to search for a goal...',
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/goals',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  $('.select.message-patient-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: ['name'],
    placeholder: 'Start typing to search for a patient...',
    options: [],
    create: false,
    plugins: ['remove_button'],
    delimiter: ',',
    persist: false,
    onDropdownClose,
    disabledField: 'disable',
    onInitialize() {
      preservePlaceholder(this);
      this.addOption({ id: -1, name: 'Enter two or more characters', disable: true });
    },
    onLoad(data) {
      this.removeOption(-1);
    },
    load(query, callback) {
      if (!query.length || query.length < 2) return callback();

      const authToken = document.querySelector('meta[name="api-auth-token"]')?.getAttribute('content');

      $.ajax({
        url: `/api/v2/patients`,
        type: 'GET',
        headers: { 'X-API-AUTH-TOKEN': `Token token=${authToken}` },
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  $('.select.activity-item-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    placeholder: 'Start typing to search for an item...',
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/activity-items',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  $('.select.word-select').selectize({
    valueField: 'id',
    labelField: 'word',
    searchField: 'word',
    placeholder: 'Start typing to search for a word...',
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/words',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  $('.select.word-group-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    placeholder: 'Start typing to search for a word group...',
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/word-groups',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  $('.select.minimal-pair-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    placeholder: 'Start typing to search for a minimal pair...',
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/minimal-pairs',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  $('.select.lemma-select').selectize({
    valueField: 'id',
    labelField: 'lemma',
    searchField: 'lemma',
    placeholder: 'Start typing to search for a lemma...',
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/lemmas',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  $('.select.activity-list-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    placeholder: 'Start typing to search for an activity list...',
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/activity-lists',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  $('.select.language-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    placeholder: 'Start typing to search for a language...',
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/languages',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  $('.select.resource-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    placeholder: 'Start typing to search for a PDF resource...',
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/resources',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  $('.select.reference-link-select').selectize({
    valueField: 'id',
    labelField: 'title',
    searchField: 'title',
    dataAttr: 'description',
    placeholder: 'Start typing to search for a reference link...',
    options: [],
    create: false,
    onDropdownClose,
    render: {
      item(item, escape) {
        if (item.author !== null && item.author !== undefined) {
          return `<div class="p-1">${item.title} <small>(${item.author})</small></div>`;
        }
        return `<div class="p-1">${item.title}</div>`;
      },
      option(item, escape) {
        if (item.author !== null && item.author !== undefined) {
          return `<div class="p-1">${item.title} <small>(${item.author})</small></div>`;
        }
        return `<div class="p-1">${item.title}</div>`;
      },
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/reference-links',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
    onChange(value) {
      const select = this.$input[0];
      const option = select.options[0];
      option.value = value;
      select.value = value;
      const data = this.options[value];
      if (data && data.description)
        select.closest('div').parentNode.querySelector('.description-field').value = data.description;
    },
    onInitialize() {
      preservePlaceholder(this);
      const select = this.$input[0].dataset;
      $.ajax({
        url: '/api/v2/reference-links',
        type: 'GET',
        dataType: 'json',
        data: {
          q: select.name,
        },
        error(e) {
          console.log(e);
        },
        success: (res) => {
          if (!res) return;
          this.addOption(res);
          const selectedItems = [];
          selectedItems.push(select.id);
          this.addItem(selectedItems);
        },
      });
    },
  });

  $('.select.university-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    placeholder: 'Start typing to search for a university...',
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      $.ajax({
        url: '/api/v2/universities',
        type: 'GET',
        dataType: 'json',
        data: {
          q: query,
        },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });

  // Used in app/views/organizations_users/_add_permission_modal.html.erb
  $('select.add-permissions').selectize({
    onDropdownClose,
    onChange(value) {
      if (value) {
        $('#grant_permission_btn').removeAttr('disabled');
      }
    },
  });

  const ruleEditPage = document.getElementById('rules_condition_modal_anchor');
  if (ruleEditPage) {
    window.pageJSLoading = true;
    import('../pages/rules-edit').then((module) => {
      const rulesEdit = module.default;
      if (rulesEdit !== undefined) rulesEdit();
      window.pageJSLoading = false;
    });
  }

  // Used in app/views/organizations_users/_add_permission_group_modal.html.erb
  $('select.add-permission-groups').selectize({
    onDropdownClose,
    // DUMMY FOR NOW
  });

  const credentialSelectHandler = () => {
    const credentialFields = document.querySelectorAll('.select.credential-select');
    const credentialFieldsValues = Array.from(credentialFields).map((field) => field.value);
    computeDisciplines(credentialFieldsValues);
  };

  const credentialFields = document.querySelectorAll('.select.credential-select');
  if (credentialFields.length > 0) {
    const credentialFieldsValues = Array.from(credentialFields).map((field) => field.value);
    computeDisciplines(credentialFieldsValues, false);
    // this sucks (because any of the filterables might not be a credential-select) but I can't figure out any other way
    filterables.on('change', credentialSelectHandler);
  }

  const genderPronoun = document.getElementById('gender_pronoun_select');
  const genderPronounWriteIn = document.getElementById('gender_pronoun_write_in');
  const genderPronounWriteInContainer = document.getElementById('gender_pronoun_write_in_container');

  const genderPronounSelectHandler = (selectEvent) => {
    if (selectEvent.target.value === 'cdc8f7a6-ea5f-4de4-9565-2564df008018') {
      genderPronounWriteInContainer.classList.remove('hidden');
    } else {
      genderPronounWriteInContainer.classList.add('hidden');
      genderPronounWriteIn.value = '';
    }
  };

  if (genderPronoun) {
    noSortFilterables.on('change', genderPronounSelectHandler);
  }

  // Added boundary window to prevent flickering when a tooltip
  // is within a responsive table (Kevin 10/2022)
  // https://stackoverflow.com/a/62076857
  $('[data-toggle="tooltip"]').tooltip({ boundary: 'window' });
  $('[data-toggle="popover"]').popover();

  const backgroundJobRows = document.querySelectorAll('.background_job_expand_handler');
  if (backgroundJobRows) {
    backgroundJobRows.forEach((jobIcon) => {
      const jobId = `background_job_expand_job_${jobIcon.id.split('_')[5]}`;
      jobIcon.onclick = () => {
        document.getElementById(jobId).classList.toggle('background_job_handler_row');
        if (jobIcon.classList.contains('bi-plus-circle')) {
          jobIcon.classList.replace('bi-plus-circle', 'bi-dash-circle');
        } else {
          jobIcon.classList.replace('bi-dash-circle', 'bi-plus-circle');
        }
      };
    });
  }

  initSortableList();
});
